var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgMapBw = function SvgMapBw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "map-bw_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".map-bw_svg__st2{fill:#fdfefe}.map-bw_svg__st4{fill:#999}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 23.6h-2.7c-.2-.2-.4-.1-.6-.2C3.7 22.3-.5 16.5.4 10.2 1.4 4.1 7-.2 13.2.4c4.9.5 8.8 3.9 10 8.6.2.6.2 1.2.4 1.7v2.5c-.1.1-.1.2-.1.3-.6 4.7-4 8.5-8.6 9.8-.5.1-1.1.1-1.6.3zm-4.4-5.9c1.8-.5 3.5-1.1 5.3-1.7l6.3 1.8c-.1-.3-.2-.4-.2-.5-1.1-2.3-2.2-4.5-3.3-6.8-.4-.8-.8-1.5-1.8-1.4h-.1c.1-.4.3-.7.4-1.1.3-.6.3-1.3.1-2-.5-2.1-2.7-3.3-4.8-2.6-1.9.4-3.3 2.6-2.4 4.7.1.3.3.5.3.8-.3.1-.7 0-1-.1-.3-.2-.5 0-.7.3-.9 1.9-1.8 3.9-2.7 5.8-.5 1-.5 1 .6 1.4.1 0 .2.1.2.1 1.3.4 2.5 1 3.8 1.3z",
    fill: "#bdbdbd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 8.7c0-.3-.2-.5-.3-.8-.9-2.1.5-4.4 2.4-5 2.1-.7 4.4.6 4.9 2.7.2.7.2 1.4-.1 2-.2.4-.3.8-.5 1.1l-.5.9-1.1 1.7-1.6 2.1c-.8-.9-1.4-1.9-2.1-2.8l-.4-.7-.6-1c0-.1 0-.2-.1-.2zm5.3-2.4c0-1.1-.9-2-1.9-2-1.1 0-2 .9-2 2 0 .9 1 2.1 1.8 2.1 1.1 0 2.1-.9 2.1-2.1z",
    fill: "#555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "map-bw_svg__st2",
    d: "M14.6 9.7l.5-.9h.1c1 0 1.4.6 1.8 1.5 1.1 2.4 2.3 4.7 3.4 7 .1.1.1.3.2.5L14.1 16c-.1-.4-.1-.8-.2-1.3l4.2 1.1c-.1-.3-.2-.6-.3-.8-.6-1.4-1.3-2.8-1.9-4.2-.2-.6-.5-1.1-1.3-1.1zm-5.9-.9l.6 1c-.4 0-.8 0-1.2-.1-.4-.1-.5 0-.7.3-.7 1.6-1.5 3.3-2.3 4.9-.2.3-.1.4.2.5 1.2.4 2.4.7 3.6 1.1l-.2 1.3c-1.2-.3-2.4-.8-3.7-1.2-.1 0-.2-.1-.2-.1-1.1-.4-1.1-.4-.6-1.5.8-2 1.8-4 2.7-6 .2-.4.3-.5.8-.4.3.1.7.2 1 .1-.1.1 0 .1 0 .1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 17.8l.2-1.3.1-.1c.2-.1.4-.1.6-.2 1.4-.5 2.8-1 4.3-1.4.1.4.1.8.2 1.3-1.8.6-3.6 1.2-5.4 1.7z",
    fill: "#e4e8ed"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "map-bw_svg__st4",
    d: "M9.1 16.4l-.1.1c-1.2-.4-2.4-.7-3.6-1.1-.3-.1-.4-.2-.2-.5.8-1.6 1.5-3.3 2.3-4.9.2-.3.3-.4.7-.3.4.1.8.1 1.2.2l.5.8c-.2 1.5-.5 3.1-.7 4.6-.1.3-.4.7-.1 1.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1 16.4c-.3-.4 0-.8 0-1.2.2-1.5.5-3.1.7-4.6.7.9 1.3 1.9 2.1 2.8l1.6-2.1c.2 1.1.4 2.3.4 3.4-1.5.4-2.9 1-4.3 1.4-.1.2-.3.3-.5.3z",
    fill: "#888"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "map-bw_svg__st4",
    d: "M14 14.8c-.1-1.1-.3-2.3-.4-3.4l1.1-1.7c.8 0 1.1.5 1.3 1.1.6 1.4 1.2 2.8 1.9 4.2.1.2.2.5.3.8l-4.2-1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "map-bw_svg__st2",
    d: "M13.9 6.3c0 1.1-1 2.1-2.1 2.1-.8 0-1.8-1.2-1.8-2.1 0-1.1.9-2 2-2 1 .1 1.9.9 1.9 2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7 8.8c-.1 0-.1 0-.1-.1.1 0 .1.1.1.1z",
    fill: "#90deaa"
  })));
};

export default SvgMapBw;